import React, { useEffect, useState } from 'react';
import { LoadSceneEvent, RoomCodeChangedEvent, WarsEvents, WarsScenes } from '@playroomkit/pr-wars/events';
import { useManager } from '@src/contexts/WarsContext';
import './RoomCode.css';
import ScalableWrapper from '@components/ScalableWrapper';
import View from '@components/View';
import { platform } from '@playroomkit/pr-common';
import { WebEngineEvents } from '@playroomkit/pr-webengine/events';

const RoomCode: React.FC = () => {

    const manager = useManager();
    const [roomCode, setRoomCode] = useState<string | null>(manager.roomCode);
    const [showUI, setShowUI] = useState(false);

    useEffect(() => {
        const handleRoomCodeChange = (event: Event) => {
            let e = event as RoomCodeChangedEvent;
            
            setRoomCode(e.roomCode);
        }

        const handleLoadSceneEvents = (event: Event) => {
            let e = event as LoadSceneEvent,
              display = e.sceneName === WarsScenes.SelectAvatar;
            
            setShowUI(display);
        }

        const handleToggleUI = (event: Event) => {
            if(showUI) {
                setShowUI(false);
            }
        }

        document.addEventListener(WarsEvents.RoomCodeEvent, handleRoomCodeChange);
        document.addEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
        document.addEventListener(WebEngineEvents.ToggleUIEvent, handleToggleUI);

        return () => {
            document.removeEventListener(WarsEvents.RoomCodeEvent, handleRoomCodeChange);
            document.removeEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvents);
            document.removeEventListener(WebEngineEvents.ToggleUIEvent, handleToggleUI);
        }

    }, [roomCode, showUI])

    if (platform.isRunningInDiscord) {
        return <></>;
    }

    return (
    <>
        {showUI && (
            <View className="room-code-wrapper">
                <ScalableWrapper maintainAspectRatioBy="height" anchor="bottom-left">
                    <View className="room-code-container">
                        <View className="room-code">
                            {roomCode}
                        </View>
                    </View>
                </ScalableWrapper>
            </View>
        )}
    </>
    );
};

export default RoomCode;
